import React from 'react';
import Font_image from './font_site_vmmi.png';
import user_picture from './user_picture.png';
import Bounce from 'react-reveal/Bounce';
import Flip from 'react-reveal/Flip';
import Fade from 'react-reveal/Fade';
import Slide from 'react-reveal/Slide';
import Zoom from 'react-reveal/Zoom';
import { BrowserView, MobileView, isBrowser, isMobile} from "react-device-detect";

import { BrowserRouter as Router, Switch, Route, Link,Redirect,HashRouter } from 'react-router-dom';
import { 
  FaArrowDown, 
  FaEnvelope, 
  FaCode, 
  FaWpforms, 
  FaCommentDots, 
  FaShoppingCart 
} from 'react-icons/fa';
import { FaSquareFacebook } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";
import { FiInstagram } from "react-icons/fi";
import { MdEmail } from "react-icons/md";
import { RiMailFill } from "react-icons/ri";

const features = [
    {
      icon: <FaArrowDown size={60} />,
      title: "RAKOTORATOKO Member VMMI",
      desc: "Allows you to configure after login redirection to a specific page based on the member's level",
      color: "#4A90E2"
    },
    {
      icon: <FaEnvelope size={60} />,
      title: "RAKOTORATOKO Member VMMI",
      desc: "Allows you to signup the member to your MailChimp list after registration",
      color: "#4A90E2"
    },
    {
      icon: <FaCode size={60} />,
      title: "RAKOTORATOKO Member VMMI",
      desc: "Simple Membership Addon to generate form shortcode for specific membership level.",
      color: "#4A90E2"
    },
    {
      icon: <FaWpforms size={60} />,
      title: "RAKOTORATOKO Member VMMI",
      desc: "Allows you to fully customize the fields that appear on the registration and edit profile forms of your membership site",
      color: "#4A90E2"
    },
    {
      icon: <FaCommentDots size={60} />,
      title: "RAKOTORATOKO Member VMMI",
      desc: "Custom Messages addon allows you to customize the content protection message that gets output from the",
      color: "#4A90E2"
    },
    {
      icon: <FaShoppingCart size={60} />,
      title: "RAKOTORATOKO Member VMMI",
      desc: "This addon can be used to accept membership payment via the WooCommerce plugin",
      color: "#4A90E2"
    }
  ];

class Accueil extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      countNumber: 0
    };
  }

  render() {
    return (

      <div>

        <div className="home-data" id="accueil" style={{backgroundImage:`url(${Font_image})` ,backgroundSize: 'cover', backgroundRepeat: 'no-repeat', height: '100vh' }} >
          
          {/*<div className="title-header" style={{fontSize:isBrowser? "3em" :"1.5em"}}>Bienvenue chez VMMI, guides experts en italien pour découvrir Madagascar avec passion et authenticité.</div>*/}

        </div>

        {/* ABOUT US*/}
        <div className="about-us" id="aboutus" style={{ clear: "both" }}>

          <Zoom>
            <div className='align-items-center'>
              <p style={{color:"#2ecc71", fontWeight:"bold", fontSize:"3em", textAlign:'center', paddingTop:isBrowser?'10px':'20px'}}>
                A propos de V.M.M.i
              </p>
            </div>
          </Zoom>

          <div>

            <BrowserView>
  
              <div style={{width:"100%"}}>
                <img src={Font_image} alt="Vondron'ny Mpitaridia Miteny Italiana"  className="float-end me-4 mb-4 rounded shadow" style={{ width: '48%', height:"60vh", padding:"20px", margin:"30px" }}/>
                <div >
                  <p style={{fontSize:"34px", padding:"20px"}}>
                    <span>Le <strong>V.M.M.I.</strong> est une association malgache de guides touristiques. Son nom complet est <strong>Vondron'ny Mpitaridia Miteny Italiana</strong>, ce qui signifie Groupe des guides qui parlent italien.<br /></span>
                    <span>Créé pour aider les visiteurs italiens, ses membres accompagnent les touristes en leur expliquant l'histoire, la culture et les beautés de Madagascar dans un italien clair et simple. Ils rendent les visites plus agréables et faciles à comprendre.<br /></span>
                    <span>Grâce au <strong>V.M.M.I.</strong>, les touristes découvrent Madagascar de manière authentique tout en se sentant bien accueillis. C'est une équipe professionnelle et passionnée qui facilite les échanges entre l'Italie et Madagascar.</span>
                  </p>
                </div>
                
              </div>

            </BrowserView>

            <MobileView>

              <div className="d-flex flex-column align-items-center justify-content-center" style={{marginTop:"-60px"}}>

                  <div className="d-flex align-items-center justify-content-center" style={{width:"100%", padding:"10px"}}>
                    <img src={Font_image} alt="Vondron'ny Mpitaridia Miteny Italiana" className="float-start me-4 mb-4 rounded shadow" style={{width:"100%", height:"250px", padding:"20px", margin:"30px"}}/>
                  </div>

                  <div className="d-flex flex-column align-items-center justify-content-center" style={{width:"100%", marginTop:"-20px", fontSize:"20px"}}>
                    <span>Le <strong>V.M.M.I.</strong> est une association malgache de guides touristiques. Son nom complet est <strong>Vondron'ny Mpitaridia Miteny Italiana</strong>, ce qui signifie « Groupe des guides qui parlent italien ».<br /></span>
                    <span>Créé pour aider les visiteurs italiens, ses membres accompagnent les touristes en leur expliquant l'histoire, la culture et les beautés de Madagascar dans un italien clair et simple. Ils rendent les visites plus agréables et faciles à comprendre.<br /></span>
                    <span>Grâce au <strong>V.M.M.I.</strong>, les touristes découvrent Madagascar de manière authentique tout en se sentant bien accueillis. C'est une équipe professionnelle et passionnée qui facilite les échanges entre l'Italie et Madagascar.</span>
                  </div>
                  
              </div>

            </MobileView>

          </div>
          
        </div>

       

        {/* MEMBERS */}
        <div className="list_member" id="members" style={{ clear: "both" }}>

          <hr className="lineseparator-data"></hr>

          <Zoom>
            <div className='align-items-center'>
              <p style={{color:"#2ecc71", fontWeight:"bold", fontSize:isBrowser?"3em":"2em", textAlign:'center', paddingTop:isBrowser?'-40px':'0px'}}>
                Les membres de V.M.M.I.
              </p>
            </div>
          </Zoom>

          <div>

            <BrowserView>
       
              <div className='listedata justify-content-center'>

                {features.map((feature, index) => (


                  <div key={index} className="card-list-desktop" style={{marginTop:"-10px"}}>
                    <div className="column">

                      <img variant="top" src={user_picture} style={{width:"90%", height:"250px",margin:"1rem",resizeMode:"contain", borderRadius:"10px"}}  alt='13'/>
                      <div style={{width:"100%"}}>

                        <p style={{fontSize:"1.2rem", fontWeight:"bold", textAlign:"center"}}>{feature.title}</p>
                        {/*<p style={{fontSize:'1rem', margin:"1rem",maxHeight:"6rem",overflowX:"none"}}>{feature.desc}</p>*/}

                        <div className=" d-flex flex-row justify-content-center align-items-center">
                          <div className="contactlist'">  
                            <a href="mailto:contact@vmmi.mg" target="_blank"><RiMailFill style={{color: '#2980b9', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                          </div>

                          <div className="contactlist'">  
                            <a href="https://facebook.com/ArmelMadagascar" target="_blank"><FaSquareFacebook style={{ color: '#2980b9', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                          </div>

                          <div className="contactlist'">  
                              <a href="https://linkedin.com/in/exoticmadagascar" target="_blank"><FaLinkedin style={{color: '#2980b9', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                          </div>

                          <div className="contactlist'">  
                              <a href="https://www.instagram.com/armel_madagascar/" target="_blank"><FiInstagram style={{color: '#2980b9', marginTop:10,marginBottom:10}}/></a>
                          </div>

                        </div>
  
                      </div>

                    </div>
                  </div>

                ))}
                          
              </div>

            </BrowserView>

            <MobileView>

              <div className="d-flex flex-column align-items-center justify-content-center" style={{marginTop:"-20px"}}>

                  {features.map((feature, index) => (


                  <div key={index} className="card-list-mobile" style={{marginTop:"20px"}}>
                    <div className="column">

                      <img variant="top" src={user_picture} style={{width:"90%", height:"300px", margin:"1rem",resizeMode:"contain", borderRadius:"10px"}}  alt='13'/>
                      <div style={{width:"100%"}}>

                        <p style={{fontSize:"1.2rem", fontWeight:"bold", textAlign:"center"}}>{feature.title}</p>
                        {/*<p style={{fontSize:'1rem', margin:"1rem",maxHeight:"6rem",overflowX:"none"}}>{feature.desc}</p>*/}

                        <div className=" d-flex flex-row justify-content-center align-items-center">
                          <div className="contactlist'">  
                            <a href="mailto:contact@vmmi.mg" target="_blank"><RiMailFill style={{color: '#2980b9', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                          </div>

                          <div className="contactlist'">  
                            <a href="https://facebook.com/ArmelMadagascar" target="_blank"><FaSquareFacebook style={{color: '#2980b9', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                          </div>

                          <div className="contactlist'">  
                              <a href="https://linkedin.com/in/exoticmadagascar" target="_blank"><FaLinkedin style={{color: '#2980b9', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                          </div>

                          <div className="contactlist'">  
                              <a href="https://www.instagram.com/armel_madagascar/" target="_blank"><FiInstagram style={{ color: '#2980b9', marginTop:10,marginBottom:10}}/></a>
                          </div>

                        </div>
  
                      </div>

                    </div>
                  </div>

                ))}
                 
              </div>

            </MobileView>

          </div>
          
        </div>

        {/* FOOTER */}
        <div id="contact" className="justify-content-center footer" style={{marginTop:"20px",clear: "both"}}>
          <div className=" d-flex flex-row justify-content-center align-items-center" style={{paddingTop:"20px"}}>
            <div className="contactlist">  
              <a href="mailto:contact@vmmi.mg" target="_blank"><RiMailFill style={{fontSize:'30' , color: '#2980b9', marginTop:10,marginBottom:10, marginRight:10}}/></a>
            </div>

            <div className="contactlist'">  
              <a href="https://facebook.com/ArmelMadagascar" target="_blank"><FaSquareFacebook style={{fontSize:'30' , color: '#2980b9', marginTop:10,marginBottom:10, marginRight:10}}/></a>
            </div>

            <div className="contactlist'">  
                <a href="https://linkedin.com/in/exoticmadagascar" target="_blank"><FaLinkedin style={{fontSize:'30' , color: '#2980b9', marginTop:10,marginBottom:10, marginRight:10}}/></a>
            </div>

            <div className="contactlist'">  
                <a href="https://www.instagram.com/armel_madagascar/" target="_blank"><FiInstagram style={{fontSize:'30' , color: '#2980b9', marginTop:10,marginBottom:10}}/></a>
            </div>

          </div>

        <div className="text-center">
          <div className="py-1">
            <p className="textombrenoir" style={{ color:'white',fontSize:"20px"}}>
              Copyright &copy; {new Date().getFullYear()} Tous les droits réservés à V.M.M.I.
            </p>                                                     
          </div>
        </div>
        </div>

      </div>

    );
  }
}

export default Accueil;